import panel from './src/panel';

export default panel;


// WEBPACK FOOTER //
// ./src/components/panel/index.js